export default __webpack_public_path__ + "static/media/telegram.a1468376.svg";